import { FileDown } from 'lucide-react'

import { TextLink } from '@/modules/Frontend/UiBlocks'

import { useProductAttributes } from '../../../state'

export function AttachmentsComponent() {
  const { configAttachments } = useProductAttributes()
  const attributes = configAttachments?.attributes ?? []

  if (attributes.length === 0) return null

  return (
    <div className="pl-5 pb-3 pt-3 block bg-cards-bg xl:bg-inherit" id="hexamarvel-attachments">
      <ul>
        {attributes.map((attachmentGroup, index) => {
          const attachment = attachmentGroup[0]
          if (!attachment) return null

          const label = index === 0 ? 'Manual utilizare' : attachment.name
          const tooltip = index === 0 ? 'Copiaza manual utilizare' : attachment.name

          return (
            <li
              key={attachment.fileUrl}
              className="flex flex-row gap-2 items-center justify-center md:justify-start xl:justify-start m-0"
            >
              <FileDown className="w-5 h-5 text-text-color" />
              <div className="group relative inline-block hover:cursor-pointer">
                <TextLink
                  variant="muted"
                  size="base"
                  href={attachment.fileUrl}
                  external
                  className="leading-4"
                >
                  {label}
                </TextLink>
                <span className="absolute bg-white max-w-[360px] min-w-[250px] p-4 z-50 hidden md:group-hover:block left-[115%] top-[-80%] text-left text-gray-500 leading-7 border border-gray-400 mt-1.5 text-sm xl:text-lg">
                  {tooltip}
                </span>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
